<script>
import ExcelJS from 'exceljs'
import gql from 'graphql-tag'
import cloneDeep from 'lodash/cloneDeep'
import toNumber from 'lodash/toNumber'
import Swal from 'sweetalert2'
import { mapGetters } from 'vuex'

/** Três cenários de ocupação (dias/piquete) conforme a quantidade de piquetes do módulo. */
function suggestedOccupationsByPaddockCount (rawCount) {
  const n = Math.max(0, Math.floor(Number(rawCount)))
  if (n <= 2) return [20, 25, 30]
  if (n === 3) return [12, 15, 18]
  if (n === 4) return [10, 12, 14]
  if (n === 5) return [8, 9, 10]
  if (n === 6) return [6, 7, 8]
  if (n === 7) return [5, 6, 7]
  if (n <= 10) return [4, 5, 6]
  if (n <= 14) return [3, 4, 5]
  if (n <= 25) return [2, 3, 4]
  if (n <= 39) return [1, 2, 3]
  if (n <= 49) return [0.5, 1, 2]
  if (n <= 80) return [0.33, 0.5, 1]
  return [0.33, 0.5, 1]
}

const OCCUPATIONS_STORAGE_PREFIX = 'occupations'
const MULTIPLE_OCCUPATIONS_TTL_MS = 7 * 24 * 60 * 60 * 1000

function occupationsStorageKey (farmId) {
  return `${OCCUPATIONS_STORAGE_PREFIX}:${farmId}`
}

function loadFarmOccupationsFromStorage (farmId) {
  if (typeof localStorage === 'undefined' || !farmId) return null
  try {
    const raw = localStorage.getItem(occupationsStorageKey(farmId))
    if (!raw) return null
    const saved = JSON.parse(raw)
    if (!saved || Date.now() >= saved.expiresAt) {
      localStorage.removeItem(occupationsStorageKey(farmId))
      return null
    }
    return saved
  } catch (e) {
    return null
  }
}

function saveFarmOccupationsToStorage (farmId, modulesById) {
  if (typeof localStorage === 'undefined' || !farmId) return
  const now = Date.now()
  localStorage.setItem(
    occupationsStorageKey(farmId),
    JSON.stringify({
      savedAt: now,
      expiresAt: now + MULTIPLE_OCCUPATIONS_TTL_MS,
      modules: modulesById,
    })
  )
}

export default {
  components: {
    modalResults: () => import('./ModalDataResults.vue')
  },

  data () {
    return {
      loadingBatch: false,
      showAlert: false,
      loadingFarms: false,
      loadingModules: false,
      loadingCalc: false,
      dialogCalcResult: false,
      showSupplementation: false,
      reference_month: new Date().toISOString().substr(0, 7),
      lastFarm: localStorage.getItem('lastFarm'),
      lastModule: localStorage.getItem('lastModule'),
      modalDateRef: false,
      enableMultiple: false,
      valid: null,
      dialogOccupation: false,
      params: {},
      form: {},
      farms: [],
      modules: [],
      batch: [],
      calcs: [
        { value: 'NUMBER_OF_HEADS_THAT_FIT_IN_MODULE', text: 'Quantas cabeças cabem neste módulo' },
        { value: 'NUMBER_OF_HEADS_PER_PERFORMANCE_GOAL', text: 'Quantidade de cabeças por meta de desempenho' },
        { value: 'WHAT_IS_THE_EXPECTED_WEIGHT_GAIN_IN_THIS_BATCH', text: 'Qual o ganho de peso esperado neste lote' },
      ],

      daysOccupations: [
        { value: 0.33, text: '8 horas/piquete' },
        { value: 0.5, text: '12 horas/piquete' },
        { value: 1, text: '1 dia/piquete' },
        { value: 2, text: '2 dias/piquete' },
        { value: 3, text: '3 dias/piquete' },
        { value: 4, text: '4 dias/piquete' },
        { value: 5, text: '5 dias/piquete' },
        { value: 6, text: '6 dias/piquete' },
        { value: 7, text: '7 dias/piquete' },
        { value: 8, text: '8 dias/piquete' },
        { value: 9, text: '9 dias/piquete' },
        { value: 10, text: '10 dias/piquete' },
        { value: 11, text: '11 dias/piquete' },
        { value: 12, text: '12 dias/piquete' },
        { value: 13, text: '13 dias/piquete' },
        { value: 14, text: '14 dias/piquete' },
        { value: 15, text: '15 dias/piquete' },
        { value: 16, text: '16 dias/piquete' },
        { value: 17, text: '17 dias/piquete' },
        { value: 18, text: '18 dias/piquete' },
        { value: 19, text: '19 dias/piquete' },
        { value: 20, text: '20 dias/piquete' },
        { value: 21, text: '21 dias/piquete' },
        { value: 22, text: '22 dias/piquete' },
        { value: 23, text: '23 dias/piquete' },
        { value: 24, text: '24 dias/piquete' },
        { value: 25, text: '25 dias/piquete' },
        { value: 26, text: '26 dias/piquete' },
        { value: 27, text: '27 dias/piquete' },
        { value: 28, text: '28 dias/piquete' },
        { value: 29, text: '29 dias/piquete' },
        { value: 30, text: '30 dias/piquete' },
      ],

      occupationList: [
        { value: 0.33, text: '8h' },
        { value: 0.5, text: '12h' },
        { value: 1, text: '1 d' },
        { value: 2, text: '2 d' },
        { value: 3, text: '3 d' },
        { value: 4, text: '4 d' },
        { value: 5, text: '5 d' },
        { value: 6, text: '6 d' },
        { value: 7, text: '7 d' },
        { value: 8, text: '8 d' },
        { value: 9, text: '9 d' },
        { value: 10, text: '10 d' },
        { value: 11, text: '11 d' },
        { value: 12, text: '12 d' },
        { value: 13, text: '13 d' },
        { value: 14, text: '14 d' },
        { value: 15, text: '15 d' },
        { value: 16, text: '16 d' },
        { value: 17, text: '17 d' },
        { value: 18, text: '18 d' },
        { value: 19, text: '19 d' },
        { value: 20, text: '20 d' },
        { value: 21, text: '21 d' },
        { value: 22, text: '22 d' },
        { value: 23, text: '23 d' },
        { value: 24, text: '24 d' },
        { value: 25, text: '25 d' },
        { value: 26, text: '26 d' },
        { value: 27, text: '27 d' },
        { value: 28, text: '28 d' },
        { value: 29, text: '29 d' },
        { value: 30, text: '30 d' },
      ],

      multipleOccupations: [1,2,3],
      allModulesSelected: true,
      selectedModules: [],
      multipleOccupationsByModule: [],
      
      moduleIndex: -1,

      geneticPatterns: [
        { value: 'ZEBUINO', text: 'Zebuíno' },
        { value: 'CRUZAMENTO_INDUSTRIAL', text: 'Cruzamento industrial' },
        { value: 'CRUZAMENTO_LEITEIRO', text: 'Cruzado leiteiro' }
      ],

      categoriesAnimal: [
        { value: 'MACHO_12', text: 'Macho até 12m' },
        { value: 'MACHO_13-24', text: 'Macho 13-24m' },
        { value: 'MACHO_+24', text: 'Macho +24m' },
        { value: 'FEMEA_12', text: 'Fêmea até 12m' },
        { value: 'FEMEA_13-24', text: 'Fêmea 13-24m' },
        { value: 'FEMEA_+24', text: 'Fêmea +24m' },
      ],

      categoriesComplementary: [
        { value: 'FEMEA_13-24_DESAFIO', text: 'Novilha desafio', category: 'FEMEA_13-24' },
        { value: 'FEMEA_13-24_PRENHA', text: 'Novilha prenha', category: 'FEMEA_13-24' },
        { value: 'FEMEA_13-24_DESCARTE', text: 'Novilha engorda', category: 'FEMEA_13-24' },
        { value: 'FEMEA_13-24_RECRIA', text: 'Novilha recria', category: 'FEMEA_13-24' },
        { value: 'FEMEA_+24_NOVILHA_PRENHA', text: 'Novilha prenha', category: 'FEMEA_+24' },
        { value: 'FEMEA_+24_NOVILHA_VAZIA', text: 'Novilha vazia', category: 'FEMEA_+24' },
        { value: 'FEMEA_+24_NOVILHA_DESCARTE', text: 'Novilha engorda', category: 'FEMEA_+24' },
        { value: 'FEMEA_+24_PARIDA_PRENHA', text: 'Vaca parida prenha', category: 'FEMEA_+24' },
        { value: 'FEMEA_+24_PARIDA_VAZIA', text: 'Vaca parida vazia', category: 'FEMEA_+24' },
        { value: 'FEMEA_+24_SOLTEIRA_PRENHA', text: 'Vaca solteira prenha', category: 'FEMEA_+24' },
        { value: 'FEMEA_+24_SOLTEIRA_VAZIA', text: 'Vaca solteira vazia', category: 'FEMEA_+24' },
        { value: 'FEMEA_+24_DESCARTE', text: 'Vaca descarte', category: 'FEMEA_+24' },
      ],

      headerModuleDataAndAdjustedOffer: [
        { text: 'label', value: 'label', align: 'right' },
        { text: 'value', value: 'value', align: 'right' },
      ],

      headerResults: [
        { text: 'label', value: 'label', align: 'right' },
        { text: 'value', value: 'value', align: 'right' },
      ],

      multipleWeight: [
        { label: "Garote de Recria", value: 270, category: 'MACHO_13-24', categoryComplementary: null },
        { label: "Novilha de Recria", value: 240, category: 'FEMEA_13-24', categoryComplementary: 'FEMEA_13-24_RECRIA' },
        { label: "Boi de Engorda", value: 500, category: 'MACHO_+24', categoryComplementary: null },
        { label: "Vaca Parideira", value: 450, category: 'FEMEA_+24', categoryComplementary: 'FEMEA_+24_PARIDA_PRENHA' }
      ],

      configModuleDataAndAdjustedOffer: {
        moduleArea: { label: 'Área do módulo (ha)', color: 'brown darken-2 white--text', position: 1 },
        qtdPaddocks: { label: 'Quantidade de piquetes', color: 'brown darken-2 white--text', position: 2 },
        availableDryMatter: { label: 'Matéria seca disponível (kg/piquete)', color: 'yellow darken-3 white--text', position: 3 },
        crudeProtein: { label: 'Proteína bruta', color: 'yellow darken-3 white--text', position: 4 },
        fiberInNeutralDetergent: { label: 'Fibra em detergente neutro', color: 'yellow darken-3 white--text', position: 5 },
        metabolizableEnergy: { label: 'Energia Metabolizável (Mcal/kg)', color: 'yellow darken-3 white--text', position: 6 },
        ndt: { label: 'NDT', color: 'yellow darken-3 white--text', position: 7, hidden: true },
        ndtAdjusted: { label: 'NDT', color: 'yellow darken-3 white--text', position: 7 },
      },

      configResults: {
        averageBatchWeight: { label: 'Peso médio do lote', hidden: true, position: 1 },
        numberOfHeads: { label: 'Cabeças', hidden: true, position: 2 },
        expectedPerformance: { label: 'Desempenho previsto (g/cabeça/dia)', hidden: true, position: 3 },
        expectedConsumption: { label: 'Consumo esperado de pasto (kg MS/cab/dia)', position: 4 },
        consumptionByLiveWeight: { label: 'Consumo / Peso vivo', position: 5 },
        moduleCapacity: { label: 'Lotação do módulo (UA/ha)', position: 6 },
        instantPicketCharge: { label: 'Carga Instantânea do piquete (UA/ha)', position: 7 },
        restTime: { label: 'Tempo de descanso (dias)', position: 8 },
        arrobasProduced: { label: 'Arrobas produzidas/hectare/mês', position: 9 },
      },

      configMultipleResults: {
        averageBatchWeight: { label: 'Peso médio do lote', hidden: true, position: 1 },
        numberOfHeads: { label: 'Cabeças', position: 2 },
        expectedPerformance: { label: 'Desempenho previsto (g/cabeça/dia)', position: 3 },
        expectedConsumption: { label: 'Consumo esperado de pasto (kg MS/cab/dia)', position: 4 },
        consumptionByLiveWeight: { label: 'Consumo / Peso vivo', position: 5 },
        moduleCapacity: { label: 'Lotação do módulo (UA/ha)', position: 6 },
        instantPicketCharge: { label: 'Carga Instantânea do piquete (UA/ha)', position: 7 },
        restTime: { label: 'Tempo de descanso (dias)', position: 8 },
        arrobasProduced: { label: 'Arrobas produzidas/hectare/mês', position: 9 },
      },

      moduleDataAndAdjustedOffer: [],
      results: [],
      multipleResults: [],
      resultsRaw: { results: {} },
      categoriesComplementaryFiltred: [],

      validations: {
        farm: [(v) => !!v || 'Fazenda é obrigatório'],
        module: [(v) => !!v || 'Módulo é obrigatório'],
        calc_type: [(v) => !!v || 'Tipo de cálculo é obrigatório'],
        day_occupation: [(v) => !!v || 'Ocupação é obrigatório'],
        genetic_pattern: [(v) => !!v || 'Padrão genético é obrigatório'],
        category_animal: [(v) => !!v || 'Categoria animal é obrigatório'],
        category_complementary: [(v) => (this.categoriesComplementaryFiltred.length === 0 || !!v) || 'Categoria complementar é obrigatório'],
        average_batch_weight: [(v) => !!v || 'Peso médio do lote é obrigatório'],
        supplement_mineral_consumption: [(v) => {
          if (v && this.form.average_batch_weight) {
            const consumeMS = this.form.supplement_mineral_consumption * this.params['MINERAL_MS_PERC']
            const percent = (consumeMS / this.form.average_batch_weight) * 100
            return percent <= this.params['SUPPLEMENT_MS_MINERAL_LIMIT'] || 'Qtd. de MS excedeu o limite'
          }
          return true
        }],

        supplement_feed_consumption: [(v) => {
          if (v && this.form.average_batch_weight) {
            const consumeMS = this.form.supplement_feed_consumption * this.params['FEED_MS_PERC']
            const percent = (consumeMS / this.form.average_batch_weight) * 100
            return percent <= this.params['SUPPLEMENT_MS_FEED_LIMIT'] || 'Qtd. de MS excedeu o limite'
          }
          return true
        }],

        supplement_vol_ms: [(v) => {
          if (v && this.form.average_batch_weight) {
            const consumeMS = this.form.supplement_vol_consumption * (v / 100)
            const percent = (consumeMS / this.form.average_batch_weight) * 100
            return percent <= this.params['SUPPLEMENT_MS_VOL_LIMIT'] || 'Qtd. de MS excedeu o limite'
          }
          return true
        }],

        supplement_enabled: [(v) => {
          if (v && this.form.average_batch_weight) {
            let consumeMS = 0
            if (this.form.supplement_mineral_consumption) {
              consumeMS += this.form.supplement_mineral_consumption * this.params['MINERAL_MS_PERC']
            }
            if (this.form.supplement_feed_consumption) {
              consumeMS += this.form.supplement_feed_consumption * this.params['FEED_MS_PERC']
            }
            if (this.form.supplement_vol_consumption && this.form.supplement_vol_ms) {
              consumeMS += this.form.supplement_vol_consumption * this.form.supplement_vol_ms / 100
            }
            const percent = (consumeMS / this.form.average_batch_weight) * 100
            return percent <= this.params['SUPPLEMENT_MS_TOTAL_LIMIT'] || 'Consumo de matéria seca excedeu o limite do peso do animal.'
          }
          return true
        }],
      }
    }
  },

  computed: {
    ...mapGetters('auth', ['isManager','user']),

    supplementConsumption () {
      if (this.form.supplement_enabled) {
        return toNumber(this.form.supplement_mineral_consumption || 0) + toNumber(this.form.supplement_feed_consumption || 0) + toNumber(this.form.supplement_vol_consumption || 0)
      }
      return null
    },

    alertExpectedPerformance () {
      return this.form.calc_type == 'NUMBER_OF_HEADS_PER_PERFORMANCE_GOAL' && this.resultsRaw.results.maxPerformance < this.form.expected_performance
    },

    resultTitle () {
      const item = this.calcs.find(item => item.value === this.form.calc_type)
      if (item) return item.text
      return ''
    },

    farmSelected () {
      const farm = this.farms.find(item => item.id === this.form.farm_id)
      if (!farm) null
      return farm
    },

    moduleSelected () {
      const module = this.modules.find(item => item.value === this.form.module_id)
      if (!module) null
      return module
    },

    daysOccupationsSelected () {
      const day_occupation = this.daysOccupations.find(item => item.value === this.form.day_occupation)
      if (!day_occupation) null
      return day_occupation
    },

    geneticPatternsSelected () {
      const geneticPattern = this.geneticPatterns.find(item => item.value === this.form.genetic_pattern)
      if (!geneticPattern) null
      return geneticPattern
    },

    categoriesAnimalSelected () {
      const categoriesAnimal = this.categoriesAnimal.find(item => item.value === this.form.category_animal)
      if (!categoriesAnimal) null
      return categoriesAnimal
    },

    categoriesComplementarySelected () {
      const categoryComplementary = this.categoriesComplementary.find(item => item.value === this.form.category_complementary)
      if (!categoryComplementary) null
      return categoryComplementary
    },

    animalLabel () {
      if (this.categoriesComplementaryFiltred.length > 0) {
        return `${this.geneticPatternsSelected && this.geneticPatternsSelected.text} / ${this.categoriesAnimalSelected && this.categoriesAnimalSelected.text} / ${this.categoriesComplementarySelected && this.categoriesComplementarySelected.text}`
      }
      return `${this.geneticPatternsSelected && this.geneticPatternsSelected.text} / ${this.categoriesAnimalSelected && this.categoriesAnimalSelected.text}`
    },

    monthLabel () {
      const monthNames = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
      const arrDate = this.reference_month.split('-')
      const year = arrDate[0]
      const month = Number(arrDate[1])
      return `${monthNames[month - 1]}/${year}`
    }
  },

  watch: {
    'form.farm_id': function () {
      this.batch = {}
      //this.form.module_id = this.$route.query.module_id;
    },

    'batch.id': function() {
      this.loadingBatch = true;
      if (typeof this.batch.average_weight !== 'undefined') this.form.average_batch_weight = this.batch.average_weight.toFixed(1)
      if (typeof this.batch.number_of_heads !== 'undefined') this.form.number_of_heads = this.batch.number_of_heads
      if (typeof this.batch.category_animal !== 'undefined') this.form.category_animal = this.batch.category_animal
      this.showCategoryComplementary()
      if (typeof this.batch.category_complementary !== 'undefined') this.form.category_complementary = this.batch.category_complementary
      if (typeof this.batch.genetic_pattern !== 'undefined') this.form.genetic_pattern = this.batch.genetic_pattern;
      if (typeof this.batch.day_occupation !== 'undefined') this.form.day_occupation = this.batch.day_occupation;
      if (this.batch.supplement_mineral_consumption) this.form.supplement_mineral_consumption = this.batch.supplement_mineral_consumption;
      if (this.batch.supplement_mineral_pb) this.form.supplement_mineral_pb = this.batch.supplement_mineral_pb;
      if (this.batch.supplement_mineral_ndt) this.form.supplement_mineral_ndt = this.batch.supplement_mineral_ndt;
      if (this.batch.supplement_feed_consumption) this.form.supplement_feed_consumption = this.batch.supplement_feed_consumption;
      if (this.batch.supplement_feed_pb) this.form.supplement_feed_pb = this.batch.supplement_feed_pb;
      if (this.batch.supplement_feed_ndt) this.form.supplement_feed_ndt = this.batch.supplement_feed_ndt;
      if (this.batch.supplement_feed_fdn) this.form.supplement_feed_fdn = this.batch.supplement_feed_fdn;
      if (this.batch.supplement_vol_consumption) this.form.supplement_vol_consumption = this.batch.supplement_vol_consumption;
      if (this.batch.supplement_vol_ms) this.form.supplement_vol_ms = this.batch.supplement_vol_ms;
      if (this.batch.supplement_vol_pb) this.form.supplement_vol_pb = this.batch.supplement_vol_pb;
      if (this.batch.supplement_vol_em) this.form.supplement_vol_em = this.batch.supplement_vol_em;
      if (this.batch.supplement_vol_fdn) this.form.supplement_vol_fdn = this.batch.supplement_vol_fdn;
      this.loadingBatch = false;
    }
  },

  created () {
    this.init()
  },

  methods:{
    async init() {
      this.form.module_id = this.$route.query.module_id
      this.fetchParams()
      await this.fetchFarms()
      if (this.farms[0]) {
        this.lastFarm = localStorage.getItem('lastFarm')
        this.lastModule = localStorage.getItem('lastModule')
        if(this.lastFarm) {
          this.$set(this.form, 'farm_id', this.$route.query.farm_id || this.lastFarm)
          await this.fetchModules()
          if (this.$route.query.module_id) {
            this.$set(this.form, 'module_id', this.$route.query.module_id)
            await this.fetchBatches()
          } else {
              this.$set(this.form, 'module_id', this.lastModule)
              this.handleModuleChange(this.lastModule)
              if (this.lastModule !== 'Todos') {
                await this.fetchBatches()
              }
          }
          if (this.$route.query.module_id) {
            this.$set(this.form, 'supplement_enabled', this.batch.supplement_enabled)
          }
        }
      }
    },

    setLastFarm() {
      if(this.farms[0]) this.lastFarm = localStorage.setItem('lastFarm', this.form.farm_id)
    },

    setLastModule() {
      if(this.modules[0]) this.lastModules = localStorage.setItem('lastModule', this.form.module_id)
    },

    checkUser() {
      if (!this.isManager) {
        if (this.form && this.form.farm_id) {
          let farm = {}
          for (let index = 0; index < this.farms.length; index++ ) {
            if (this.farms[index].id === this.form.farm_id) {
              farm = this.farms[index]
              break
            }
          }
          if (farm.desactivated) {
            return true
          } else {
            return false
          }
        }
      } else {
        return false
      }
    },

    changeSupplementEnabled () {
      if (!this.form.supplement_enabled) {
        this.form.supplement_mineral_consumption = null
        this.form.supplement_mineral_pb = null
        this.form.supplement_mineral_ndt = null
        this.form.supplement_feed_consumption = null
        this.form.supplement_feed_pb = null
        this.form.supplement_feed_ndt = null
        this.form.supplement_feed_fdn = null
        this.form.supplement_vol_consumption = null
        this.form.supplement_vol_ms = null
        this.form.supplement_vol_pb = null
        this.form.supplement_vol_em = null
        this.form.supplement_vol_fdn = null
      }
    },
  
    async calc(){
      if (!this.$refs.form.validate()) return false;
      this.loadingCalc = true
      try {
        const form = cloneDeep(this.form)
        form.reference_month = this.reference_month
        form.number_of_heads = toNumber(form.number_of_heads)
        form.average_batch_weight = toNumber(form.average_batch_weight)
        form.expected_performance = toNumber(form.expected_performance)
        form.supplement_mineral_consumption = toNumber(form.supplement_mineral_consumption)
        form.supplement_mineral_pb = toNumber(form.supplement_mineral_pb)
        form.supplement_mineral_ndt = toNumber(form.supplement_mineral_ndt)
        form.supplement_feed_consumption = toNumber(form.supplement_feed_consumption)
        form.supplement_feed_pb = toNumber(form.supplement_feed_pb)
        form.supplement_feed_ndt = toNumber(form.supplement_feed_ndt)
        form.supplement_feed_fdn = toNumber(form.supplement_feed_fdn)
        form.supplement_vol_consumption = toNumber(form.supplement_vol_consumption)
        form.supplement_vol_ms = toNumber(form.supplement_vol_ms)
        form.supplement_vol_pb = toNumber(form.supplement_vol_pb)
        form.supplement_vol_em = toNumber(form.supplement_vol_em)
        form.supplement_vol_fdn = toNumber(form.supplement_vol_fdn)
        form.calculator = true
        form.ignore_paddock_limit = false
        form.batch_number_of_heads = toNumber(form.number_of_heads)
        form.batch_general_average_weight = toNumber(form.average_batch_weight)
        const res = await this.$apollo.query({
          query: gql`
            query calc($data: CalcInput!) {
              calc(
                data: $data
              ) {
                result
              }
            }
          `,
          variables: {
            data: form
          },
          fetchPolicy: 'no-cache',
        });
        this.resultsRaw = res.data.calc.result
        this.results = Object.entries(res.data.calc.result.results)
        .map(([name, value]) => {
          return {
            name,
            value,
            ...this.processResults(name, value)
          }
        })
        .filter(item => item.label && !item.hidden)
        .sort((a, b) => a.position > b.position ? 1 : -1);
        this.$store.dispatch('analytics/trackEvent', { event: 'Calculate', params: form })
        this.moduleDataAndAdjustedOffer = Object.entries(res.data.calc.result.moduleDataAndAdjustedOffer)
        .map(([name, value]) => {
          return {
            name,
            value,
            ...this.configModuleDataAndAdjustedOffer[name]
          }
        })
        .filter(item => item.label && !item.hidden)
        .sort((a, b) => a.position > b.position ? 1 : -1);

      } catch (e) {
        const graphQLError = e?.graphQLErrors[0]
        if(graphQLError?.extensions?.code === 'business') {
          Swal.fire({ icon: 'error', text: graphQLError?.message });
        } else {
          console.error(e);
        }
      }

      this.loadingCalc = false
    },

    async calcAndExport() {
      this.loadingCalc = true
      this.results = []
      try {
        await this.multipleCalc()
        await this.exportToCsv()
      } catch (e) {
        let graphQLError
        if (e && e.graphQLErrors) {
          graphQLError = e.graphQLErrors[0]
        } else {
          graphQLError = e
        }
        if(graphQLError?.extensions?.code === 'business') {
          Swal.fire({ icon: 'error', text: graphQLError?.message });
        } else {
          console.error('erro : ', e);
        }
      } finally {
        this.loadingCalc = false
      }
    },

    async multipleCalc() {
  this.multipleResults = [];

  for (let index = 0; index < this.multipleOccupationsByModule.length; index++) {
    const module = this.multipleOccupationsByModule[index];
    if (module.selected) {
      this.multipleResults.push({});
      this.multipleResults[this.multipleResults.length - 1].moduleName = module.moduleName;

      // Usando for...of para o loop assíncrono
      for (const day of module.occupations) {
        this.multipleResults[this.multipleResults.length - 1][day] = {};

        // Usando for...of para o loop assíncrono em multipleWeight
        for (const weight of this.multipleWeight) {
          try {
            const form = cloneDeep(this.form);
            form.reference_month = this.reference_month;
            form.module_id = module.moduleId;
            form.number_of_heads = toNumber(form.number_of_heads);
            form.day_occupation = toNumber(day);
            form.calc_type = 'NUMBER_OF_HEADS_THAT_FIT_IN_MODULE';
            form.genetic_pattern = 'ZEBUINO';
            form.category_animal = weight.category;
            form.category_complementary = weight.categoryComplementary;
            form.average_batch_weight = toNumber(weight.value);
            form.expected_performance = toNumber(form.expected_performance);
            form.supplement_mineral_consumption = toNumber(form.supplement_mineral_consumption);
            form.supplement_mineral_pb = toNumber(form.supplement_mineral_pb);
            form.supplement_mineral_ndt = toNumber(form.supplement_mineral_ndt);
            form.supplement_feed_consumption = toNumber(form.supplement_feed_consumption);
            form.supplement_feed_pb = toNumber(form.supplement_feed_pb);
            form.supplement_feed_ndt = toNumber(form.supplement_feed_ndt);
            form.supplement_feed_fdn = toNumber(form.supplement_feed_fdn);
            form.supplement_vol_consumption = toNumber(form.supplement_vol_consumption);
            form.supplement_vol_ms = toNumber(form.supplement_vol_ms);
            form.supplement_vol_pb = toNumber(form.supplement_vol_pb);
            form.supplement_vol_em = toNumber(form.supplement_vol_em);
            form.supplement_vol_fdn = toNumber(form.supplement_vol_fdn);
            form.calculator = true;
            form.ignore_paddock_limit = false
            form.batch_number_of_heads = toNumber(form.number_of_heads)
            form.batch_general_average_weight = toNumber(form.average_batch_weight)
            let res = await this.$apollo.query({
              query: gql`
                query calc($data: CalcInput!) {
                  calc(data: $data) {
                    result
                  }
                }
              `,
              variables: {
                data: form
              },
              fetchPolicy: 'no-cache',
            });

            this.resultsRaw = res.data.calc.result;
            const results = Object.entries(res.data.calc.result.results)
              .map(([name, value]) => {
                return {
                  name,
                  value,
                  ...this.processMultipleResults(name, value)
                };
              })
              .filter(item => item.label && !item.hidden)
              .sort((a, b) => a.position > b.position ? 1 : -1);
            
            if (!this.multipleResults[this.multipleResults.length - 1].moduleData) {
              this.$store.dispatch('analytics/trackEvent', { event: 'Calculate', params: form })
              const moduleDataAndAdjustedOffer = Object.entries(res.data.calc.result.moduleDataAndAdjustedOffer)
              .map(([name, value]) => {
                return {
                  name,
                  value,
                  ...this.configModuleDataAndAdjustedOffer[name]
                }
              })
              .filter(item => item.label && !item.hidden)
              .sort((a, b) => a.position > b.position ? 1 : -1);
              this.multipleResults[this.multipleResults.length - 1].moduleData = moduleDataAndAdjustedOffer

              form.ignore_paddock_limit = true
              form.batch_number_of_heads = toNumber(form.number_of_heads)
              form.batch_general_average_weight = toNumber(form.average_batch_weight)
              res = await this.$apollo.query({
                query: gql`
                  query calc($data: CalcInput!) {
                    calc(data: $data) {
                      result
                    }
                  }
                `,
                variables: {
                  data: form
                },
                fetchPolicy: 'no-cache',
              });
              // all Paddocks
              this.$store.dispatch('analytics/trackEvent', { event: 'Calculate', params: form })
              const moduleDataAndAdjustedOfferAllPaddocks = Object.entries(res.data.calc.result.moduleDataAndAdjustedOffer)
              .map(([name, value]) => {
                return {
                  name,
                  value,
                  ...this.configModuleDataAndAdjustedOffer[name]
                }
              })
              .filter(item => item.label && !item.hidden)
              .sort((a, b) => a.position > b.position ? 1 : -1);
              this.multipleResults[this.multipleResults.length - 1].moduleDataAllPaddocks = moduleDataAndAdjustedOfferAllPaddocks
            }
            // Atualizando multipleResults com os resultados
            this.multipleResults[this.multipleResults.length - 1][day][weight.label] = {};
            this.multipleResults[this.multipleResults.length - 1][day][weight.label].weight = weight.value;
            this.multipleResults[this.multipleResults.length - 1][day][weight.label].calcs = results;

          } catch (e) {
            let graphQLError
            if (e && e.graphQLErrors) {
              graphQLError = e.graphQLErrors[0]
            } else {
              graphQLError = e
            }
            if(graphQLError?.extensions?.code === 'business') {
              Swal.fire({ icon: 'error', text: graphQLError?.message + ' no módulo : ' + module.moduleName });
              break
            } else {
              console.error(e);
            }
          }
        }
      }
    }
  }
},

    async exportToCsv() {
      try {
      var CsvString = "";
      let CsvStringByModule = {};
      var averageModuleString = "";
      var moduleDataString = "";
      var preGrazingString = "";
      const infoByCategory = []
      let minTime = 0
      let maxTime = 0
      const capacityByCategory = {}
      for (const module of this.multipleResults) {
        let days = Object.keys(module)
        days = days.filter(key => (key !== 'moduleName' && key !== 'moduleData' && key !== 'moduleDataAllPaddocks'))
        const info = {}
        minTime = String(Math.min(...days.map(Number)))
        maxTime = String(Math.max(...days.map(Number)))
        info.moduleName = module.moduleName
        CsvStringByModule[module.moduleName] = ""
        info.moduleData = module.moduleData
        info.moduleDataAllPaddocks = module.moduleDataAllPaddocks
        CsvStringByModule[module.moduleName] += '\ufeff' + module.moduleName + ';'
        CsvStringByModule[module.moduleName] += "\r\n";
        CsvStringByModule[module.moduleName] += '\ufeff' + 'Ocupação por piquete (dias)' + ';'
        //CsvString += '\ufeff' + module.moduleName + ';'
        //CsvString += "\r\n";
        //CsvString += '\ufeff' + 'Ocupação por piquete (dias)' + ';'
        days.forEach(function(day) {
          CsvStringByModule[module.moduleName] += '\ufeff' + day + ';'
          //CsvString += '\ufeff' + day + ';'
        })
        CsvStringByModule[module.moduleName] += "\r\n";
        CsvStringByModule[module.moduleName] += '\ufeff' + 'Tempo de descanso (dias)' + ';'
        //CsvString += "\r\n";
        //CsvString += '\ufeff' + 'Tempo de descanso (dias)' + ';'
        for (const day of days) {
          const calcDay = module[day];
          const categories = Object.keys(calcDay);
          const calcCategory = calcDay[categories[0]]; // Acessando o primeiro item de categorias corretamente
          const formattedValue = (calcCategory.calcs[6].value.toFixed(0)).replace('.', ',')
          CsvStringByModule[module.moduleName] += '\ufeff' + formattedValue + ';';
          //CsvString += '\ufeff' + formattedValue + ';';
        }
        CsvStringByModule[module.moduleName] += "\r\n"
        CsvStringByModule[module.moduleName] += "\r\n"
        //CsvString += "\r\n";
        //CsvString += "\r\n";
        for (const day of days) {
          const calcDay = module[day]
          const categories = Object.keys(calcDay)
          for (const category of categories) {
            const categoryDay = calcDay[category]
            
            if (!info[category]) {
              info[category] = {}
              info[category].numberOfHeads = []
              info[category].expectedPerformance = []
              info[category].comsumption = []
              info[category].consumptionByLiveWeight = []
              info[category].moduleCapacity = []
              info[category].restTime = []
            }
            info[category].numberOfHeads.push(categoryDay.calcs[0].value)
            info[category].expectedPerformance.push(categoryDay.calcs[1].value)
            info[category].comsumption.push(categoryDay.calcs[2].value)
            info[category].consumptionByLiveWeight.push(categoryDay.calcs[3].value)
            info[category].moduleCapacity.push(categoryDay.calcs[4].value)
            info[category].restTime.push(categoryDay.calcs[6].value)
            info[category].weight = categoryDay.weight
            if (!capacityByCategory[category]) {
              capacityByCategory[category] = {}
              capacityByCategory[category].weight = categoryDay.weight
              capacityByCategory[category].min = 0
              capacityByCategory[category].max = 0
            }
            if (day === minTime) {
              capacityByCategory[category].min = capacityByCategory[category].min + Number(categoryDay.calcs[0].value)
              capacityByCategory[category].minModuleCapacity = categoryDay.calcs[4].value
            } else if (day === maxTime) {
              capacityByCategory[category].max = capacityByCategory[category].max + Number(categoryDay.calcs[0].value)
              capacityByCategory[category].maxModuleCapacity = categoryDay.calcs[4].value
            }
          }

        }
        infoByCategory.push(info)
      }
      averageModuleString += '\ufeff' + 'Média Geral do Módulo'
      averageModuleString += "\r\n\r\n";
      averageModuleString += '\ufeff' + 'Módulo ou Setor' + ';'
      averageModuleString += '\ufeff' + 'Quantidade de piquetes' + ';'
      averageModuleString += '\ufeff' + 'Área (ha/piquete)' + ';'
      averageModuleString += '\ufeff' + 'MS Total (kg/piquete)' + ';'
      averageModuleString += '\ufeff' + 'MS Área (kg/ha)'
      averageModuleString += "\r\n";

      moduleDataString += '\ufeff' + 'Módulo ou Setor' + ';'
      moduleDataString += '\ufeff' + 'PB (%)' + ';'
      moduleDataString += '\ufeff' + 'EM (kcal/kg)' + ';'
      moduleDataString += '\ufeff' + 'FDN (%)' + ';'
      moduleDataString += '\ufeff' + 'NDT (%)'
      moduleDataString += "\r\n";

      preGrazingString += '\ufeff' + 'Média de Pré Pastejo'
      preGrazingString += "\r\n\r\n";
      preGrazingString += '\ufeff' + 'Módulo ou Setor' + ';'
      preGrazingString += '\ufeff' + 'MS Total (kg/piquete)' + ';'
      preGrazingString += '\ufeff' + 'PB (%)' + ';'
      preGrazingString += '\ufeff' + 'EM (kcal/kg)' + ';'
      preGrazingString += '\ufeff' + 'FDN (%)' + ';'
      preGrazingString += '\ufeff' + 'NDT (%)' + ';'
      preGrazingString += "\r\n";

      for (const module of infoByCategory) {
        const keysWithModule = Object.keys(module);
        const keys =  keysWithModule.filter(key => (key !== 'moduleName' && key !== 'moduleData' && key !== 'moduleDataAllPaddocks'));
        //CsvString += '\ufeff' + module.moduleName + ';'
        //CsvString += "\r\n\r\n";
        // name
        averageModuleString += '\ufeff' + module.moduleName + ';'
        // paddocks count
        averageModuleString += '\ufeff' + module.moduleDataAllPaddocks[1].value + ';'
        // area by paddock
        const areaByPaddock = (module.moduleDataAllPaddocks[0].value/ module.moduleDataAllPaddocks[1].value).toFixed(2)
        averageModuleString += '\ufeff' + areaByPaddock.replace('.', ',') + ';'
        // total ms (kg/paddock)
        averageModuleString += '\ufeff' + module.moduleDataAllPaddocks[2].value.toFixed(0).replace('.', ',') + ';'
        // ms area (kg/ha)
        averageModuleString += '\ufeff' + (module.moduleDataAllPaddocks[2].value / areaByPaddock).toFixed(0).replace('.', ',')  + ';'
        averageModuleString += "\r\n";

        const fExport = this.effectiveNutrientAdjustFactors(this.modules.find((mo) => mo.text === module.moduleName))
        moduleDataString += '\ufeff' + module.moduleName + ';'
        moduleDataString += '\ufeff' + (module.moduleDataAllPaddocks[3].value * fExport.pb * 100).toFixed(1).replace('.', ',') + ';'
        moduleDataString += '\ufeff' + (module.moduleDataAllPaddocks[5].value * fExport.em * 1000).toFixed(0).replace('.', ',') + ';'
        moduleDataString += '\ufeff' + (module.moduleDataAllPaddocks[4].value * fExport.fdn * 100).toFixed(1).replace('.', ',') + ';'
        moduleDataString += '\ufeff' + (module.moduleDataAllPaddocks[6].value * 100).toFixed(1).replace('.', ',') + ';'
        moduleDataString += "\r\n";

        preGrazingString += '\ufeff' + module.moduleName + ';'
        preGrazingString += '\ufeff' + module.moduleData[2].value.toFixed(0).replace('.', ',') + ';'
        preGrazingString += '\ufeff' + (module.moduleData[3].value * fExport.pb * 100).toFixed(1).replace('.', ',') + ';'
        preGrazingString += '\ufeff' + (module.moduleData[5].value * fExport.em * 1000).toFixed(0).replace('.', ',') + ';'
        preGrazingString += '\ufeff' + (module.moduleData[4].value * fExport.fdn * 100).toFixed(1).replace('.', ',') + ';'
        preGrazingString += '\ufeff' + (module.moduleData[6].value * 100).toFixed(1).replace('.', ',') + ';'
        preGrazingString += "\r\n";
        for (const key of keys) {
          const calc = module[key];
          // Adicionando informações ao CSV
          CsvStringByModule[module.moduleName] += '\ufeff' + key + ': ' + calc.weight + ' kg de peso vivo';
          CsvStringByModule[module.moduleName] += "\r\n\r\n";
          //CsvString += '\ufeff' + key + ': ' + calc.weight + ' kg de peso vivo';
          //CsvString += "\r\n\r\n";
          
          /* //CsvString += '\ufeff' + 'Lotação média do módulo (UA/ha)' + ';';
          for (const value of calc.moduleCapacity) {
            const formattedValue = (value.toFixed(2)).replace('.', ',');
            //CsvString += '\ufeff' + formattedValue + ';';
          }
          //CsvString += "\r\n"; */
          CsvStringByModule[module.moduleName] += '\ufeff' + 'Consumo de pasto (kg de MS/cab/dia)' + ';';
          //CsvString += '\ufeff' + 'Consumo de pasto (kg de MS/cab/dia)' + ';';
          for (const value of calc.comsumption) {
            const formattedValue = (value.toFixed(2)).replace('.', ',');
            CsvStringByModule[module.moduleName] += '\ufeff' + formattedValue + ';';
            //CsvString += '\ufeff' + formattedValue + ';';
          }
          CsvStringByModule[module.moduleName] += "\r\n";
          //CsvString += "\r\n";
          
          CsvStringByModule[module.moduleName] += '\ufeff' + 'Relação de consumo x peso vivo (%)' + ';';
          //CsvString += '\ufeff' + 'Relação de consumo x peso vivo (%)' + ';';
          for (const value of calc.consumptionByLiveWeight) {
            const formattedValue = (value.toFixed(2)).replace('.', ',');
            CsvStringByModule[module.moduleName] += '\ufeff' + formattedValue + ';';
            //CsvString += '\ufeff' + formattedValue + ';';
          }
          CsvStringByModule[module.moduleName] += "\r\n";
          //CsvString += "\r\n";
          
          CsvStringByModule[module.moduleName] += '\ufeff' + 'Capacidade de Suporte (cabeças)' + ';';
          //CsvString += '\ufeff' + 'Capacidade de Suporte (cabeças)' + ';';
          for (const value of calc.numberOfHeads) {
            const formattedValue = (value.toFixed(0)).replace('.', ',');
            CsvStringByModule[module.moduleName] += '\ufeff' + formattedValue + ';';
            //CsvString += '\ufeff' + formattedValue + ';';
          }
          CsvStringByModule[module.moduleName] += "\r\n";
          //CsvString += "\r\n";
          if (key !== 'Vaca Parideira') {
            CsvStringByModule[module.moduleName] += '\ufeff' + 'Desempenho individual (g/cab/dia)' + ';';
            //CsvString += '\ufeff' + 'Desempenho individual (g/cab/dia)' + ';';
            for (const value of calc.expectedPerformance) {
              let min; let max
              if (Number(value) < 50) {
                min = '0'
                max = '50'
              } else {
                min = (value * 0.95).toFixed(0).replace('.', ',')
                max = (value * 1.05).toFixed(0).replace('.', ',')
              }
              CsvStringByModule[module.moduleName] += '\ufeff' + min + ' - ' + max + ';';
              ////CsvString += '\ufeff' + min + ' - ' + max + ';';
            }
          }
          CsvStringByModule[module.moduleName] += "\r\n\r\n";
          // //CsvString += "\r\n\r\n";
        }
      }
      CsvString += '\ufeff' + 'Capacidade Suporte de animais nos módulos' + ';';
      CsvString += "\r\n\r\n";
      CsvString += '\ufeff' + 'Tempo de ocupação' + ';'+ minTime +';' + maxTime;
      CsvString += "\r\n";
      const categoryKeys = Object.keys(capacityByCategory);
      for (const key of categoryKeys) {
        const item = capacityByCategory[key]
        CsvString += '\ufeff' + key + ': ' + item.weight + ' kg de peso vivo' + ';' + item.min + ';' + item.max;
        CsvString += "\r\n";
      }
      const modulesKeys = Object.keys(CsvStringByModule)
      // eslint-disable-next-line no-unused-vars
      let CsvFileString = ""
      for (const key of modulesKeys) {
        const item = CsvStringByModule[key]
        CsvFileString += item;
        CsvFileString += "\r\n\r\n";
      }
      // //CsvString += "\r\n\r\n";
      CsvFileString += CsvString;
      CsvFileString += "\r\n\r\n";
      CsvFileString += averageModuleString;
      CsvFileString += "\r\n\r\n";
      CsvFileString += moduleDataString;
      CsvFileString += "\r\n\r\n";
      CsvFileString += preGrazingString;
      CsvFileString += "\r\n\r\n";
      // eslint-disable-next-line no-unused-vars
      CsvFileString = "data:application/csv," + encodeURIComponent(CsvFileString);

      let fileName = ""
      const farmItem = this.farms.find(obj => obj.id === this.form.farm_id);
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0'); // Janeiro = 0
      const day = String(now.getDate()).padStart(2, '0');
      const hour = String(now.getHours()).padStart(2, '0');
      const minute = String(now.getMinutes()).padStart(2, '0');
      fileName = `${farmItem.text}_${year}${month}${day}_${hour}${minute}.csv`;

      // ── Geração do XLSX formatado ──
      const workbook = new ExcelJS.Workbook()
      const ws = workbook.addWorksheet('Resultados')
      const ws2 = workbook.addWorksheet('Capacidade e médias')

      const greenFill = {
        type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFB5E6A2' },
      }
      const grayFill = {
        type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE8E8E8' },
      }
      /** Cor vinho (bordô) para «X kg de peso vivo» — saturada e avermelhada (ARGB). */
      const liveWeightFontColor = { argb: 'FFC41E3A' }
      /** Tipografia principal do export (XLSX): Aptos Serif 11 pt. */
      const xlsxFontAptosSerif11 = {
        name: 'Aptos Serif',
        family: 1,
        size: 11,
        color: { argb: 'FF000000' },
      }

      // ExcelJS: alinhamento vertical «ao centro» é 'middle' (não 'center', que a API ignora)
      const centerAlign = { horizontal: 'center', vertical: 'middle' }

      const moduleTitleStyle = {
        font: { ...xlsxFontAptosSerif11, bold: true },
        fill: grayFill,
        alignment: centerAlign,
      }
      /** Linhas «Ocupação por piquete» / «Tempo de descanso»: fundo branco, negrito (antes eram cinza). */
      const occupancyRestRowStyle = {
        font: { ...xlsxFontAptosSerif11, bold: true },
        alignment: centerAlign,
      }
      const categoryStyle = {
        font: { ...xlsxFontAptosSerif11, bold: true },
        fill: greenFill,
        alignment: centerAlign,
      }
      const sectionTitleStyle = {
        font: { ...xlsxFontAptosSerif11, bold: true },

        alignment: centerAlign,
      }
      const grayRowStyle = {
        font: { ...xlsxFontAptosSerif11, bold: true },
        fill: grayFill,
        alignment: centerAlign,
      }
      const colHeaderStyle = {
        font: { ...xlsxFontAptosSerif11, bold: true },

        fill: grayFill,
        alignment: centerAlign,
      }
      const dataStyle = {
        font: { ...xlsxFontAptosSerif11 },
        alignment: centerAlign,
      }

      /** Alturas pedidas em px convertidas para pontos Excel (altura no Excel usa pt; ~ px×72/96 a 96 dpi). */
      const xlsxPtFromPx = (px) => px * (72 / 96)
      const xlsxRowHeightText = xlsxPtFromPx(35)
      const xlsxRowHeightBlank = xlsxPtFromPx(23)
      const rowText = (wsRef, rowNum) => {
        wsRef.getRow(rowNum).height = xlsxRowHeightText
      }
      const rowBlank = (wsRef, rowNum) => {
        wsRef.getRow(rowNum).height = xlsxRowHeightBlank
      }

      /** Linhas com coluna «Módulo / ou Setor» na aba Capacidade e médias (48 px → pt). */
      const xlsxRowHeightModuloSetorPt = xlsxPtFromPx(48)

      const xlsxTopBottomThinBorder = {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
      }
      const xlsxTopOnlyThinBorder = {
        top: { style: 'thin', color: { argb: 'FF000000' } },
      }
      const xlsxBottomOnlyThinBorder = {
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
      }

      const applyStyle = (cell, style) => {
        cell.font = style.font
        if (style.fill) cell.fill = style.fill
        cell.alignment = style.alignment
      }

      const writeRow = (wsRef, rowNum, cells, style, underlineRow = false, rowEdgeBorder = null) => {
        const row = wsRef.getRow(rowNum)
        cells.forEach((val, idx) => {
          const cell = row.getCell(idx + 1)
          cell.value = val
          applyStyle(cell, style)
          if (underlineRow) cell.border = xlsxTopBottomThinBorder
          else if (rowEdgeBorder === 'top') cell.border = xlsxTopOnlyThinBorder
          else if (rowEdgeBorder === 'bottom') cell.border = xlsxBottomOnlyThinBorder
        })
        rowText(wsRef, rowNum)
        row.commit()
      }

      /** Coluna 1: texto com \n (quebra) + wrap, como célula normal no Excel. */
      const writeMetricDataRow = (wsRef, rowNum, labelText, valueCells, style, rowEdgeBorder = null) => {
        const row = wsRef.getRow(rowNum)
        const cell1 = row.getCell(1)
        cell1.value = labelText
        cell1.font = style.font
        if (style.fill) cell1.fill = style.fill
        cell1.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true }
        if (rowEdgeBorder === 'bottom') cell1.border = xlsxBottomOnlyThinBorder
        valueCells.forEach((val, idx) => {
          const cell = row.getCell(idx + 2)
          cell.value = val
          applyStyle(cell, style)
          if (rowEdgeBorder === 'bottom') cell.border = xlsxBottomOnlyThinBorder
        })
        rowText(wsRef, rowNum)
        row.commit()
      }

      const aptosHeaderFont = () => ({
        ...xlsxFontAptosSerif11,
        bold: true,
      })
      const writeWrappedColHeaderRow = (wsRef, rowNum, linePairs, underlineRow = false) => {
        const row = wsRef.getRow(rowNum)
        linePairs.forEach((pair, idx) => {
          const cell = row.getCell(idx + 1)
          const headerFont = aptosHeaderFont()
          cell.value = {
            richText: [
              { font: { ...headerFont }, text: `${pair[0]}\n` },
              { font: { ...headerFont }, text: pair[1] },
            ],
          }
          cell.font = headerFont
          if (colHeaderStyle.fill) cell.fill = colHeaderStyle.fill
          cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true }
          if (underlineRow) cell.border = xlsxTopBottomThinBorder
        })
        rowText(wsRef, rowNum)
        row.commit()
      }

      const writeModuleTitleRow = (wsRef, rowNum, text) => {
        wsRef.mergeCells(rowNum, 1, rowNum, 4)
        const cell = wsRef.getRow(rowNum).getCell(1)
        cell.value = text
        applyStyle(cell, moduleTitleStyle)
        cell.border = xlsxTopBottomThinBorder
        rowText(wsRef, rowNum)
        wsRef.getRow(rowNum).commit()
      }

      const writeCategoryRow = (wsRef, rowNum, categoryName, weightFormatted) => {
        wsRef.mergeCells(rowNum, 1, rowNum, 4)
        const cell = wsRef.getRow(rowNum).getCell(1)
        const catTitleFont = { ...xlsxFontAptosSerif11, bold: true }
        cell.value = {
          richText: [
            { font: { ...catTitleFont }, text: `${categoryName}: ` },
            { font: { ...catTitleFont, color: liveWeightFontColor }, text: `${weightFormatted} kg de peso vivo` },
          ],
        }
        cell.font = catTitleFont
        if (categoryStyle.fill) cell.fill = categoryStyle.fill
        cell.alignment = categoryStyle.alignment
        cell.border = xlsxTopOnlyThinBorder
        rowText(wsRef, rowNum)
        wsRef.getRow(rowNum).commit()
      }

      const writeSectionTitleRow = (wsRef, rowNum, text) => {
        const cell = wsRef.getRow(rowNum).getCell(1)
        cell.value = text
        applyStyle(cell, sectionTitleStyle)
        rowText(wsRef, rowNum)
        wsRef.getRow(rowNum).commit()
      }

      const browserLocale = (typeof navigator !== 'undefined' && navigator.language)
        ? navigator.language
        : 'pt-BR'
      const xlsxFmtInt = (n) => {
        if (n === '' || n == null) return n
        const num = Number(n)
        if (Number.isNaN(num)) return n
        return new Intl.NumberFormat(browserLocale, { maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(num)
      }
      const xlsxFmt1 = (n) => {
        if (n === '' || n == null) return n
        const num = Number(n)
        if (Number.isNaN(num)) return n
        return new Intl.NumberFormat(browserLocale, { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(num)
      }
      const xlsxFmt2 = (n) => {
        if (n === '' || n == null) return n
        const num = Number(n)
        if (Number.isNaN(num)) return n
        return new Intl.NumberFormat(browserLocale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(num)
      }

      let xlsxRow = 1

      // BLOCO 1: Por módulo
      for (const moduleInfo of infoByCategory) {
        const moduleResult = this.multipleResults.find(m => m.moduleName === moduleInfo.moduleName)
        let moduleDays = Object.keys(moduleResult)
        moduleDays = moduleDays.filter(key => (key !== 'moduleName' && key !== 'moduleData' && key !== 'moduleDataAllPaddocks'))

        writeModuleTitleRow(ws, xlsxRow, moduleResult.moduleName)
        xlsxRow++

        writeRow(ws, xlsxRow, ['Ocupação por piquete (dias)', ...moduleDays.map((d) => xlsxFmtInt(Number(d)))], occupancyRestRowStyle, false)
        xlsxRow++

        const restTimeValues = moduleDays.map(d => {
          const calcDay = moduleResult[d]
          const cats = Object.keys(calcDay)
          return xlsxFmtInt(calcDay[cats[0]].calcs[6].value)
        })
        writeRow(ws, xlsxRow, ['Tempo de descanso (dias)', ...restTimeValues], occupancyRestRowStyle, false)
        xlsxRow++
        rowBlank(ws, xlsxRow)
        xlsxRow++

        const keysWithModule = Object.keys(moduleInfo)
        const catKeys = keysWithModule.filter(key => (key !== 'moduleName' && key !== 'moduleData' && key !== 'moduleDataAllPaddocks'))

        for (const catKey of catKeys) {
          const calc = moduleInfo[catKey]
          writeCategoryRow(ws, xlsxRow, catKey, xlsxFmtInt(calc.weight))
          xlsxRow++

          const metrics = []

          metrics.push({
            label: 'Consumo de pasto (kg de MS/cab/dia)',
            values: calc.comsumption.map((v) => xlsxFmt2(v)),
            highlighted: false
          })
          metrics.push({
            label: 'Relação de consumo x peso vivo (%)',
            values: calc.consumptionByLiveWeight.map((v) => xlsxFmt2(v)),
            highlighted: false
          })
          metrics.push({
            label: 'Capacidade de Suporte (cabeças)',
            values: calc.numberOfHeads.map((v) => xlsxFmtInt(v)),
            highlighted: true
          })
          if (catKey !== 'Vaca Parideira') {
            metrics.push({
              label: 'Desempenho individual (g/cab/dia)',
              values: calc.expectedPerformance.map((v) => {
                if (Number(v) < 50) {
                  return `${xlsxFmtInt(0)} - ${xlsxFmtInt(50)}`
                }
                const min = v * 0.95
                const max = v * 1.05
                return `${xlsxFmtInt(min)} - ${xlsxFmtInt(max)}`
              }),
              highlighted: true
            })
          }

          for (let mi = 0; mi < metrics.length; mi++) {
            const metric = metrics[mi]
            const edgeBottom = mi === metrics.length - 1 ? 'bottom' : null
            const st = metric.highlighted ? grayRowStyle : dataStyle
            writeMetricDataRow(ws, xlsxRow, metric.label, metric.values, st, edgeBottom)
            xlsxRow++
          }
          rowBlank(ws, xlsxRow)
          xlsxRow++
        }
        rowBlank(ws, xlsxRow)
        xlsxRow++
      }

      xlsxRow = 1

      // BLOCO 2: Capacidade Suporte consolidada
      writeSectionTitleRow(ws2, xlsxRow, 'Capacidade Suporte de animais nos módulos')
      xlsxRow++
      rowBlank(ws2, xlsxRow)
      xlsxRow++
      const capHdr = xlsxRow
      ws2.mergeCells(capHdr, 1, capHdr + 2, 1)
      ws2.mergeCells(capHdr, 2, capHdr, 5)
      ws2.mergeCells(capHdr + 1, 2, capHdr + 1, 3)
      ws2.mergeCells(capHdr + 1, 4, capHdr + 1, 5)

      const capCell = (r, c, val) => {
        const cell = ws2.getRow(r).getCell(c)
        cell.value = val
        applyStyle(cell, colHeaderStyle)
        cell.border = xlsxTopBottomThinBorder
      }
      capCell(capHdr, 1, 'Categoria')
      capCell(capHdr, 2, 'Tempo de ocupação em cada módulo')
      capCell(capHdr + 1, 2, 'Curto')
      capCell(capHdr + 1, 4, 'Longo')
      capCell(capHdr + 2, 2, 'Cab')
      capCell(capHdr + 2, 3, 'UA/ha')
      capCell(capHdr + 2, 4, 'Cab')
      capCell(capHdr + 2, 5, 'UA/ha')
      ws2.getRow(capHdr).commit()
      ws2.getRow(capHdr + 1).commit()
      ws2.getRow(capHdr + 2).commit()
      rowText(ws2, capHdr)
      rowText(ws2, capHdr + 1)
      rowText(ws2, capHdr + 2)
      xlsxRow += 3

      const xlsxCategoryKeys = Object.keys(capacityByCategory)
      const black = { argb: 'FF000000' }
      const capCategoryLabelAlign = { ...centerAlign, wrapText: true }
      for (const key of xlsxCategoryKeys) {
        const item = capacityByCategory[key]
        const uaCurto = item.minModuleCapacity != null && item.minModuleCapacity !== ''
          ? Number(Number(item.minModuleCapacity).toFixed(2))
          : ''
        const uaLongo = item.maxModuleCapacity != null && item.maxModuleCapacity !== ''
          ? Number(Number(item.maxModuleCapacity).toFixed(2))
          : ''
        const row = ws2.getRow(xlsxRow)
        const labelCell = row.getCell(1)
        const aptosCat = (bold) => ({
          ...xlsxFontAptosSerif11,
          bold,
          color: black,
        })
        labelCell.value = {
          richText: [
            { font: { ...aptosCat(true) }, text: `${key}\n` },
            { font: { ...aptosCat(false) }, text: `${xlsxFmtInt(item.weight)} kg de peso vivo` },
          ],
        }
        labelCell.font = aptosCat(false)
        labelCell.alignment = capCategoryLabelAlign
        const vals = [
          xlsxFmtInt(item.min),
          uaCurto !== '' && uaCurto != null ? xlsxFmt2(uaCurto) : '',
          xlsxFmtInt(item.max),
          uaLongo !== '' && uaLongo != null ? xlsxFmt2(uaLongo) : '',
        ]
        vals.forEach((val, idx) => {
          const cell = row.getCell(idx + 2)
          cell.value = val
          applyStyle(cell, dataStyle)
        })
        row.commit()
        ws2.getRow(xlsxRow).height = xlsxRowHeightModuloSetorPt
        xlsxRow++
      }
      rowBlank(ws2, xlsxRow)
      xlsxRow++
      rowBlank(ws2, xlsxRow)
      xlsxRow++

      // BLOCO 3: Média Geral do Módulo
      writeSectionTitleRow(ws2, xlsxRow, 'Média Geral do Módulo')
      xlsxRow++
      rowBlank(ws2, xlsxRow)
      xlsxRow++
      writeWrappedColHeaderRow(ws2, xlsxRow, [
        ['Módulo ', 'ou Setor'],
        ['Quantidade', 'de piquetes'],
        ['Área', '(ha/piquete)'],
        ['MS Total', '(kg/piquete)'],
        ['MS Área', '(kg/ha)'],
      ], true)
      ws2.getRow(xlsxRow).height = xlsxRowHeightModuloSetorPt
      xlsxRow++
      for (const moduleInfo of infoByCategory) {
        const areaByPaddock = moduleInfo.moduleDataAllPaddocks[0].value / moduleInfo.moduleDataAllPaddocks[1].value
        const msTotal = moduleInfo.moduleDataAllPaddocks[2].value
        writeRow(ws2, xlsxRow, [
          moduleInfo.moduleName,
          xlsxFmtInt(moduleInfo.moduleDataAllPaddocks[1].value),
          xlsxFmt2(areaByPaddock),
          xlsxFmtInt(msTotal),
          xlsxFmtInt(msTotal / areaByPaddock),
        ], dataStyle, true)
        ws2.getRow(xlsxRow).height = xlsxRowHeightModuloSetorPt
        xlsxRow++
      }
      rowBlank(ws2, xlsxRow)
      xlsxRow++
      rowBlank(ws2, xlsxRow)
      xlsxRow++

      // BLOCO 4: Dados nutricionais do módulo
      writeWrappedColHeaderRow(ws2, xlsxRow, [
        ['Módulo ', 'ou Setor'],
        ['PB', '(%)'],
        ['EM', '(kcal/kg)'],
        ['FDN', '(%)'],
        ['NDT', '(%)'],
      ], true)
      ws2.getRow(xlsxRow).height = xlsxRowHeightModuloSetorPt
      xlsxRow++
      for (const moduleInfo of infoByCategory) {
        const d = moduleInfo.moduleDataAllPaddocks
        const fx = this.effectiveNutrientAdjustFactors(this.modules.find((mo) => mo.text === moduleInfo.moduleName))
        writeRow(ws2, xlsxRow, [
          moduleInfo.moduleName,
          xlsxFmt1(d[3].value * fx.pb * 100),
          xlsxFmtInt(d[5].value * fx.em * 1000),
          xlsxFmt1(d[4].value * fx.fdn * 100),
          xlsxFmt1(d[6].value * 100),
        ], dataStyle, true)
        ws2.getRow(xlsxRow).height = xlsxRowHeightModuloSetorPt
        xlsxRow++
      }
      rowBlank(ws2, xlsxRow)
      xlsxRow++
      rowBlank(ws2, xlsxRow)
      xlsxRow++

      // BLOCO 5: Média de Pré Pastejo
      writeSectionTitleRow(ws2, xlsxRow, 'Média de Pré Pastejo')
      xlsxRow++
      rowBlank(ws2, xlsxRow)
      xlsxRow++
      writeWrappedColHeaderRow(ws2, xlsxRow, [
        ['Módulo ', 'ou Setor'],
        ['MS Total', '(kg/piquete)'],
        ['PB', '(%)'],
        ['EM', '(kcal/kg)'],
        ['FDN', '(%)'],
        ['NDT', '(%)'],
      ], true)
      ws2.getRow(xlsxRow).height = xlsxRowHeightModuloSetorPt
      xlsxRow++
      for (const moduleInfo of infoByCategory) {
        const d = moduleInfo.moduleData
        const fx = this.effectiveNutrientAdjustFactors(this.modules.find((mo) => mo.text === moduleInfo.moduleName))
        writeRow(ws2, xlsxRow, [
          moduleInfo.moduleName,
          xlsxFmtInt(d[2].value),
          xlsxFmt1(d[3].value * fx.pb * 100),
          xlsxFmtInt(d[5].value * fx.em * 1000),
          xlsxFmt1(d[4].value * fx.fdn * 100),
          xlsxFmt1(d[6].value * 100),
        ], dataStyle, true)
        ws2.getRow(xlsxRow).height = xlsxRowHeightModuloSetorPt
        xlsxRow++
      }
      ws.getColumn(1).width = 51.9
      for (let c = 2; c <= 4; c++) {
        if (ws.getColumn(c)) ws.getColumn(c).width = 13
      }
      for (let c = 5; c <= 10; c++) {
        if (ws.getColumn(c)) ws.getColumn(c).width = 16
      }
      ws2.getColumn(1).width = 45
      for (let c = 2; c <= 10; c++) {
        if (ws2.getColumn(c)) ws2.getColumn(c).width = 16
      }

      const xlsxBuffer = await workbook.xlsx.writeBuffer()
      const xlsxBlob = new Blob([xlsxBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
      const xlsxUrl = URL.createObjectURL(xlsxBlob)
      const xlsxLink = document.createElement('a')
      xlsxLink.href = xlsxUrl
      xlsxLink.download = fileName.replace('.csv', '.xlsx')
      document.body.appendChild(xlsxLink)
      xlsxLink.click()
      document.body.removeChild(xlsxLink)
      URL.revokeObjectURL(xlsxUrl)
      } catch (e) {
        this.loadingCalc = false
        const text = (e && e.message) ? e.message : 'Erro ao exportar os resultados.'
        Swal.fire({ icon: 'error', text })
        console.error('exportToCsv', e)
      }
    },

    processResults(name, value) {
      let config = this.configResults[name]
      let warning = null
      if (name === 'moduleCapacity') {
        if (value > 5) {
          warning = 'Lotações excessivas podem prejudicar o pasto!'
        }
      } else if (name === 'restTime') {
        if (value < 30) {
          warning = 'Tempo de descanso curto, verifique se o tempo de ocupação está correto.'
        }
      }
      return {
        ...config,
        warning
      }
    },

    processMultipleResults(name, value) {
      let config = this.configMultipleResults[name]
      let warning = null
      if (name === 'moduleCapacity') {
        if (value > 5) {
          warning = 'Lotações excessivas podem prejudicar o pasto!'
        }
      } else if (name === 'restTime') {
        if (value < 30) {
          warning = 'Tempo de descanso curto, verifique se o tempo de ocupação está correto.'
        }
      }
      return {
        ...config,
        warning
      }
    },

    async fetchParams() {
      try {
        const res = await this.$apollo.query({
          query: gql`
            query Params {
              params {
                id
                info
                value
              }
            }
          `,
          fetchPolicy: 'no-cache',
        });
        const resultParams = res.data
        // Parametros ajustados
        const configParams = resultParams.params.reduce((acc, item) => {
          // return acc[item.id] = item.value
          return {...acc, [item.id]: item.value}
        }, {})
        this.params = configParams
      } catch (e) {
        console.error(e);
      }
    },

    /** Mesma regra de calc/index.js + Calculator.js: módulo > 0 usa fator do módulo; senão _GERAL; valores > 2 viram /100. */
    /** @param {object|undefined} [explicitModule] - Se omitido, usa o módulo selecionado no formulário (cálculo simples). */
    effectiveNutrientAdjustFactors (explicitModule) {
      const m = arguments.length > 0 ? explicitModule : this.moduleSelected
      const p = this.params || {}
      const pick = (moduleVal, geralKey, defaultVal) => {
        const mv = moduleVal != null && moduleVal !== '' ? Number(moduleVal) : 0
        let raw = mv > 0 ? mv : p[geralKey]
        if (raw == null || raw === '' || Number.isNaN(Number(raw))) raw = defaultVal
        let n = Number(raw)
        if (n > 2) n = n / 100
        return n
      }
      return {
        pb: pick(m && m.factor_adjust_pb, 'FACTOR_ADJUST_PB_GERAL', 1.1),
        fdn: pick(m && m.factor_adjust_fdn, 'FACTOR_ADJUST_FDN_GERAL', 0.96),
        em: pick(m && m.factor_adjust_em, 'FACTOR_ADJUST_EM_GERAL', 1),
      }
    },

    /** Valor para exibição na tabela da calculadora (PB/EM/FDN com fator); demais linhas sem alteração. */
    moduleOfferDisplayValue (item) {
      if (!item || item.value == null) return item && item.value
      const f = this.effectiveNutrientAdjustFactors()
      if (item.name === 'crudeProtein') return item.value * f.pb
      if (item.name === 'fiberInNeutralDetergent') return item.value * f.fdn
      if (item.name === 'metabolizableEnergy') return item.value * f.em
      if (item.name === 'ndtAdjusted') return item.value
      return item.value
    },

    async fetchFarms() {
      this.loadingFarms = true
      try {
        let result
        if (this.isManager) {
          result = await this.$apollo.query({
            query: gql`
              query farms {
                farms(
                  where: {
                    desactivated: {_is_null: true}
                  },
                  order_by: [{ name: asc }]
                ) {
                  id
                  name
                  desactivated
                  customer{
                    id
                    name
                  }
                }
              }
            `,
            fetchPolicy: 'no-cache',
          });
          let desactivatedFarms = await this.$apollo.query({
            query: gql`
              query farms {
                farms(
                  where: {
                    desactivated: {_eq: true}
                  },
                  order_by: [{ name: asc }]
                ) {
                  id
                  name
                  desactivated
                  customer{
                    id
                    name
                  }
                }
              }
            `,
            fetchPolicy: 'no-cache',
          });
          if (desactivatedFarms && desactivatedFarms.data && desactivatedFarms.data.farms) {
            result.data.farms = [...result.data.farms, ...desactivatedFarms.data.farms]
          }
        } else {
          result = await this.$apollo.query({
            query: gql`
              query farms {
                farms(
                  order_by: [{ name: asc }]
                ) {
                  id
                  name
                  desactivated
                  customer{
                    id
                    name
                  }
                }
              }
            `,
            fetchPolicy: 'no-cache',
          });
        }
        this.loadingFarms = false
        this.farms = result.data.farms.map(item => ({value: item.id, text: item.name, ...item}));
      } catch (e) {
        console.error(e);
      }
      this.loadingFarms = false
    },

    async fetchModules() {
      this.loadingModules = true
      try {
        const result = await this.$apollo.query({
          query: gql`
            query modules ($farmId: uuid!) {
              modules(
                where: {
                  farm_id: { _eq: $farmId }
                },
                order_by: [{ name: asc }]
              ) {
                id
                name
                factor_adjust_pb
                factor_adjust_fdn
                factor_adjust_em
                paddocks_aggregate(
                  where: { deleted_at: { _is_null: true } }
                ) {
                  aggregate {
                    count
                  }
                }
              }
            }
          `,
          variables: {
            farmId: this.form.farm_id
          },
          fetchPolicy: 'no-cache',
        });
        this.loadingModules = false
        this.modules = result.data.modules.map((item) => {
          const agg = item.paddocks_aggregate && item.paddocks_aggregate.aggregate
          const paddockCount = agg && agg.count != null ? agg.count : 0
          return {
            value: item.id,
            text: item.name,
            paddockCount,
            factor_adjust_pb: item.factor_adjust_pb,
            factor_adjust_fdn: item.factor_adjust_fdn,
            factor_adjust_em: item.factor_adjust_em,
          }
        })
        const savedFarmOccupations = loadFarmOccupationsFromStorage(this.form.farm_id)
        this.multipleOccupationsByModule = this.modules.map((module) => {
          const defaults = {
            moduleName: module.text,
            moduleId: module.value,
            paddockCount: module.paddockCount,
            selected: module.paddockCount > 0,
            occupations: [...suggestedOccupationsByPaddockCount(module.paddockCount)],
          }
          const saved = savedFarmOccupations?.modules?.[module.value]
          if (!saved) return defaults
          return {
            ...defaults,
            selected: saved.selected,
            occupations: [...saved.occupations],
          }
        })
        this.allModulesSelected =
          this.multipleOccupationsByModule.length > 0 &&
          this.multipleOccupationsByModule.every((m) => m.selected)
        const firstMod = this.multipleOccupationsByModule[0]
        this.multipleOccupations = firstMod ? [...firstMod.occupations] : [1, 2, 3]
        this.selectedModules = this.multipleOccupationsByModule.map(module => {
        return {
          value: module.moduleId,  
          text: module.moduleName 
        };
      });
      } catch (e) {
        console.error(e);
      }
      this.loadingModules = false
    },

    async fetchBatches() {
      this.loadingBatch = true;
      if (this.form.module_id) {
        try {
          const result = await this.$apollo.query({
            query: gql`
              query MyQuery($moduleId: uuid!) {
                batches(
                  where: {
                    module_id: {_eq: $moduleId},
                    status: {_eq: "ATIVO"}
                  }
                ) {
                id,
                day_occupation,
                supplement_mineral_consumption
                supplement_mineral_pb
                supplement_mineral_ndt 
                supplement_feed_consumption
                supplement_feed_pb
                supplement_feed_ndt
                supplement_feed_fdn
                supplement_vol_consumption
                supplement_vol_ms
                supplement_vol_pb
                supplement_vol_em
                supplement_vol_fdn
                supplement_enabled
                genetic_pattern,
                category_animal,
                category_complementary,
                average_weight,
                number_of_heads
                }
              }
            `,
            variables: {
              moduleId: this.form.module_id
            },
            fetchPolicy: 'no-cache',
          });
          if (result.data.batches[0]) this.batch = result.data.batches[0]
          else {
            this.batch = {};
          }
          this.loadingBatch = false;
        } catch (e) {
          console.error(e);
        }
      }
    },

    farmFilter (item, queryText) {
      const textOne = item?.name?.toLowerCase()
      const textTwo = item?.customer?.name?.toLowerCase()
      const searchText = queryText.toLowerCase()

      return textOne.indexOf(searchText) > -1 ||
        textTwo.indexOf(searchText) > -1
    },

    isVisible(field) {
      if(this.form.calc_type === 'WHAT_IS_THE_EXPECTED_WEIGHT_GAIN_IN_THIS_BATCH'){
        if (field === 'number_of_heads') return true
        if (field === 'average_batch_weight') return true
        if (field === 'category_animal') return true
      }
      if(this.form.calc_type === 'NUMBER_OF_HEADS_THAT_FIT_IN_MODULE'){
        if (field === 'average_batch_weight') return true
        if (field === 'category_animal') return true
      }
      if(this.form.calc_type === 'NUMBER_OF_HEADS_PER_PERFORMANCE_GOAL'){
        if (field === 'expected_performance') return true
        if (field === 'average_batch_weight') return true
        if (field === 'category_animal') return true
      }
      return false
    },

    showCategoryComplementary() {
      this.categoriesComplementaryFiltred = this.categoriesComplementary.filter((item) => {
        return item.category === this.form.category_animal
      })
      if (!this.categoriesComplementaryFiltred.lenght) {
        this.$set(this.form, 'category_complementary', null)
      }
    },

    openModalResults(){
      this.$refs.modalResults.$emit('open')
    },

    print() {
      window.print()
    },

    saveMultipleOccupationsForFarm () {
      if (!this.form.farm_id) return
      const modules = this.multipleOccupationsByModule.reduce((acc, module) => {
        acc[module.moduleId] = {
          selected: module.selected,
          occupations: [...module.occupations],
        }
        return acc
      }, {})
      saveFarmOccupationsToStorage(this.form.farm_id, modules)
    },

    applyOccupations() {
      this.saveMultipleOccupationsForFarm()
      this.selectedModules = this.multipleOccupationsByModule.map(module => {
        return {
          value: module.moduleId,  
          text: module.moduleName 
        };
      });
      this.dialogOccupation = false
    },

    handleModuleChange(id) {
      const selectedModule = this.modules.find(module => module.value === id);
      if (selectedModule) {
        this.moduleIndex = this.modules.indexOf(selectedModule);
      }
    },

    toggleOccupation() {
      this.multipleOccupationsByModule.forEach((module) => {
        // Filtra as ocupações, removendo as que não estão em multipleOccupations
        module.occupations = module.occupations.filter(occupation =>
          this.multipleOccupations.includes(occupation)
        );

        // Adiciona ocupações que estão em multipleOccupations, mas não estão em module.occupations
        this.multipleOccupations.forEach((occupation) => {
          if (!module.occupations.includes(occupation)) {
            module.occupations.push(occupation);
          }
        });
      });
    },

    toggleAllModules() {
      this.multipleOccupationsByModule.forEach(module => {
        module.selected = this.allModulesSelected;
      });
    }
  }
}
</script>

<template>
  <div translate="no" class="notranslate">
    <!-- <h1 class="mb-5">Calculadora</h1> -->

    <v-row>
      <v-col cols="12"
        sm="12"
        md="4">
        <h2 class="mb-0 text--secondary">Calcular índices</h2>
        <p class="text--secondary"><i>Informe os dados abaixo</i></p>


        <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="calc">
          <v-card>
            <v-card-title>
              <span class="subtitle-2">Calculadora</span>
              <v-switch v-if="isManager" v-model="enableMultiple" class="ml-2" label="Múltipla"></v-switch>
              <v-spacer></v-spacer>
              <span class="subtitle-2 text--secondary">{{ monthLabel }}</span>
              <v-dialog
                ref="dialog"
                v-model="modalDateRef"
                :return-value.sync="reference_month"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    attrs="attrs"
                    icon
                    class="mr-2"
                    v-on="on"
                  >
                    <v-icon>mdi-calendar-today</v-icon>
                  </v-btn>
                </template>
                <v-date-picker
                  v-model="reference_month"
                  type="month"
                  color="success"
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="modalDateRef = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.dialog.save(reference_month)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-card-title>
            <v-card-text>
              <v-row v-if="!enableMultiple">
                <v-col cols="12" sm="12" class="pb-0">
                  <v-autocomplete
                    v-model="form.farm_id"
                    :items="farms"
                    :loading="loadingFarms"
                    :rules="validations.farm"
                    :filter="farmFilter"
                    label="Fazenda"
                    dense
                    outlined
                    persistent-placeholder
                    @input="fetchModules"
                    @change="setLastFarm()"
                  >
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <v-list-item-title v-if="!data.item.desactivated" v-html="data.item.name"></v-list-item-title>
                        <v-list-item-title v-if="data.item.desactivated" v-html="data.item.name + ' (inativa)'"></v-list-item-title>
                        <v-list-item-subtitle v-if="data.item.customer" v-html="data.item.customer.name"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="6" sm="12" class="pb-0">
                  <v-autocomplete
                    v-model="form.module_id"
                    :disabled="!form.farm_id"
                    :items="modules"
                    :loading="loadingModules"
                    :rules="validations.modules"
                    label="Módulo"
                    dense
                    outlined
                    persistent-placeholder
                    @change="() => { fetchBatches(); setLastModule(); handleModuleChange(form.module_id); }"
                  />
                </v-col>
                <v-col cols="12" md="6" sm="12" class="pb-0">
                  <v-autocomplete
                    v-model="form.day_occupation"
                    :items="daysOccupations"
                    :loading="loadingBatch"
                    :rules="validations.day_occupation"
                    label="Ocupação"
                    dense
                    outlined
                    persistent-placeholder
                  />
                </v-col>
                <v-col cols="12" md="6" sm="12" class="pb-0">
                  <v-autocomplete
                    v-model="form.genetic_pattern"
                    :items="geneticPatterns"
                    :loading="loadingBatch"
                    :rules="validations.genetic_pattern"
                    label="Padrão genético"
                    dense
                    outlined
                    persistent-placeholder
                  />
                </v-col>
                <v-col cols="12" md="6" sm="12" class="pb-0">
                  <v-autocomplete
                    v-model="form.category_animal"
                    :items="categoriesAnimal" 
                    :loading="loadingBatch"
                    :rules="validations.category_animal"
                    label="Categoria animal"
                    dense
                    outlined
                    persistent-placeholder
                    @change="showCategoryComplementary()"
                  />
                </v-col>
                <v-col cols="12" md="6" sm="12" class="pb-0">
                  <v-text-field
                    v-model="form.average_batch_weight"
                    :loading="loadingBatch"
                    :rules="validations.average_batch_weight"
                    label="Peso médio do lote"
                    suffix="kg"
                    type="number"
                    class="text-field-right"
                    dense
                    outlined
                    persistent-placeholder
                  />
                </v-col>
                <v-col v-show="categoriesComplementaryFiltred.length" cols="12" md="6" sm="12" class="pb-0">
                  <v-autocomplete
                    v-model="form.category_complementary"
                    :items="categoriesComplementaryFiltred"
                    :rules="validations.category_complementary"
                    label="Categoria complementar"
                    dense
                    outlined
                    persistent-placeholder
                  />
                </v-col>
                <v-col cols="12" sm="12" class="pb-0">
                  <v-autocomplete
                    v-model="form.calc_type"
                    :items="calcs"
                    :rules="validations.calc_type"
                    label="O que deseja calcular?"
                    dense
                    outlined
                    persistent-placeholder
                    @change="() => result = false"
                  />
                </v-col>
                <v-col v-if="isVisible('number_of_heads')" sm="6" class="pb-0">
                  <v-text-field
                    v-model="form.number_of_heads"
                    label="Quantidade de cabeças"
                    type="number"
                    class="text-field-right"
                    dense
                    outlined
                    persistent-placeholder
                  />
                </v-col>
                <v-col v-if="isVisible('expected_performance')" sm="6" class="pb-0">
                  <v-text-field
                    v-model="form.expected_performance"
                    label="Desempenho esperado"
                    suffix="g/cab/dia"
                    type="number"
                    class="text-field-right"
                    dense
                    outlined
                    persistent-placeholder
                  />
                </v-col>
                <v-col sm='12' class="pb-0 pt-0">
                  <v-checkbox
                    v-model="form.supplement_enabled"
                    :rules="validations.supplement_enabled"
                    label='Suplementação por cabeça/dia'
                    class='pt-0'
                    dense
                    @change="changeSupplementEnabled()"
                  />
                  <v-expand-transition>
                    <div v-show="form.supplement_enabled">
                      <v-expansion-panels>
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            Mineral proteinado e/ou energético
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-row>
                              <v-col sm='6'>
                                <v-text-field
                                  v-model="form.supplement_mineral_consumption"
                                  :rules="validations.supplement_mineral_consumption"
                                  label="Consumo"
                                  suffix="kg"
                                  hint='(MN/cab/dia)'
                                  type="number"
                                  class="text-field-right"
                                  dense
                                  persistent-placeholder
                                  persistent-hint
                                  outlined
                                />
                              </v-col>
                              <v-col sm='6'>
                                <v-text-field
                                  v-model="form.supplement_mineral_pb"
                                  label="Teor de PB"
                                  suffix="%"
                                  type="number"
                                  class="text-field-right"
                                  dense
                                  persistent-placeholder
                                  persistent-hint
                                  outlined
                                />
                              </v-col>
                              <v-col sm='12'>
                                <v-text-field
                                  v-model="form.supplement_mineral_ndt"
                                  label="Teor de NDT"
                                  hint='(será convertido em EM)'
                                  suffix="%"
                                  type="number"
                                  class="text-field-right"
                                  dense
                                  persistent-placeholder
                                  persistent-hint
                                  outlined
                                />
                              </v-col>
                            </v-row>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            Ração concentrada
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-row>
                              <v-col sm='6'>
                                <v-text-field
                                  v-model="form.supplement_feed_consumption"
                                  :rules="validations.supplement_feed_consumption"
                                  label="Consumo"
                                  suffix="kg"
                                  hint='(MN/cab/dia)'
                                  type="number"
                                  class="text-field-right"
                                  dense
                                  persistent-placeholder
                                  persistent-hint
                                  outlined
                                />
                              </v-col>
                              <v-col sm='6'>
                                <v-text-field
                                  v-model="form.supplement_feed_pb"
                                  label="Teor de PB"
                                  suffix="%"
                                  type="number"
                                  class="text-field-right"
                                  dense
                                  persistent-placeholder
                                  persistent-hint
                                  outlined
                                />
                              </v-col>
                              <v-col sm='6'>
                                <v-text-field
                                  v-model="form.supplement_feed_ndt"
                                  label="Teor de NDT"
                                  hint='(será conv. em EM)'
                                  suffix="%"
                                  type="number"
                                  class="text-field-right"
                                  dense
                                  persistent-placeholder
                                  persistent-hint
                                  outlined
                                />
                              </v-col>
                              <v-col sm='6'>
                                <v-text-field
                                  v-model="form.supplement_feed_fdn"
                                  label="Teor de FDN"
                                  suffix="%"
                                  type="number"
                                  class="text-field-right"
                                  dense
                                  persistent-placeholder
                                  persistent-hint
                                  outlined
                                />
                              </v-col>
                            </v-row>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            Volumoso
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-row>
                              <v-col sm='6'>
                                <v-text-field
                                  v-model="form.supplement_vol_consumption"
                                  label="Consumo"
                                  suffix="kg"
                                  hint='(MN/cab/dia)'
                                  type="number"
                                  class="text-field-right"
                                  dense
                                  persistent-placeholder
                                  persistent-hint
                                  outlined
                                />
                              </v-col>
                              <v-col sm='6'>
                                <v-text-field
                                  v-model="form.supplement_vol_ms"
                                  :rules="validations.supplement_vol_ms"
                                  label="Teor de MS"
                                  suffix="%"
                                  type="number"
                                  class="text-field-right"
                                  dense
                                  persistent-placeholder
                                  persistent-hint
                                  outlined
                                />
                              </v-col>
                              <v-col sm='6'>
                                <v-text-field
                                  v-model="form.supplement_vol_pb"
                                  label="Teor de PB"
                                  suffix="%"
                                  type="number"
                                  class="text-field-right"
                                  dense
                                  persistent-placeholder
                                  persistent-hint
                                  outlined
                                />
                              </v-col>
                              <v-col sm='6'>
                                <v-text-field
                                  v-model="form.supplement_vol_em"
                                  label="Teor de EM"
                                  suffix="Mcal/kg"
                                  type="number"
                                  class="text-field-right"
                                  dense
                                  persistent-placeholder
                                  persistent-hint
                                  outlined
                                />
                              </v-col>
                              <v-col sm='12'>
                                <v-text-field
                                  v-model="form.supplement_vol_fdn"
                                  label="Teor de FDN"
                                  suffix="%"
                                  type="number"
                                  class="text-field-right"
                                  dense
                                  persistent-placeholder
                                  persistent-hint
                                  outlined
                                />
                              </v-col>
                            </v-row>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </div>
                  </v-expand-transition>
                </v-col>
                <v-col sm="12">
                  <v-btn
                    block
                    color="success"
                    :loading="loadingCalc"
                    :disabled="checkUser()"
                    @click="calc"
                  >
                    calcular
                  </v-btn>
               </v-col>
              </v-row>
              <v-row v-if="enableMultiple">
                <v-col cols="12" sm="12" class="pb-0">
                  <v-autocomplete
                    v-model="form.farm_id"
                    :items="farms"
                    :loading="loadingFarms"
                    :rules="validations.farm"
                    :filter="farmFilter"
                    label="Fazenda"
                    dense
                    outlined
                    persistent-placeholder
                    @input="fetchModules"
                    @change="setLastFarm()"
                  >
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <v-list-item-title v-if="!data.item.desactivated" v-html="data.item.name"></v-list-item-title>
                        <v-list-item-title v-if="data.item.desactivated" v-html="data.item.name + ' (inativa)'"></v-list-item-title>
                        <v-list-item-subtitle v-if="data.item.customer" v-html="data.item.customer.name"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="12" sm="12">
                  <v-btn
                    block
                    color="#2196F3"
                    class="white--text"
                    @click="dialogOccupation = true"
                  >
                    Ocupação Geral
                  </v-btn>
                </v-col>
                
                <v-dialog v-model="dialogOccupation" max-width="none" persistent>
                  <v-card>
                    <v-card-title>
                    </v-card-title>

                    <v-card-text>
                      <!-- Tabela -->
                      <v-simple-table>
                        <thead>
                          <tr>
                            <th class="text-left" style="vertical-align: middle; font-size: 18px;">Módulos</th>
                            <th class="text-left" style="vertical-align: middle; font-size: 18px;">Ocupações</th>
                          </tr>
                          <tr>
                            <th class="text-left" style="border-bottom: 2px solid #D3D3D3 ;">
                              <v-checkbox 
                                v-model="allModulesSelected"
                                :label="'Selecionar Todos'"
                                @change="toggleAllModules" 
                              />
                            </th>
                            <th style="border-bottom: 2px solid #D3D3D3 ;">
                              <v-row dense>
                                  <v-col
                                    v-for="(occupation, occupationIndex) in occupationList"
                                    :key="occupation.value"
                                    cols="12"
                                    sm="2"
                                    md="1"
                                  >
                                    <v-checkbox
                                      v-model="multipleOccupations"
                                      :label="occupation.text"
                                      :value="occupation.value"
                                      @change="toggleOccupation()"
                                    />
                                  </v-col>
                                </v-row>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <!-- Iterando sobre cada módulo -->
                          <tr v-for="(module, moduleIndex) in multipleOccupationsByModule" :key="moduleIndex">
                            <td>
                              <div class="d-flex align-start">
                                <v-checkbox
                                  v-model="module.selected"
                                  hide-details
                                  class="mt-0 pt-0 shrink"
                                />
                                <div class="pl-1 pt-1">
                                  <div>{{ module.moduleName }}</div>
                                  <div class="text-caption text--secondary">
                                    {{ module.paddockCount === 1 ? '1 piquete' : (module.paddockCount + ' piquetes') }}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td>
                              <!-- Verificando se o módulo está selecionado -->
                              <v-row dense>
                                <v-col
                                  v-for="(occupation, occupationIndex) in occupationList"
                                  :key="occupation.value"
                                  cols="12"
                                  sm="2"
                                  md="1"
                                >
                                  <v-checkbox
                                    v-model="module.occupations"
                                    :label="occupation.text"
                                    class="checkbox-label-top"
                                    :value="occupation.value"
                                  />
                                </v-col>
                              </v-row>
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-card-text>

                    <v-card-actions class="justify-end">
                      <v-btn @click="dialogOccupation = false">Fechar</v-btn>
                      <v-btn color="success" @click="applyOccupations">Aplicar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-col v-for="(weight, index) in multipleWeight " :key="index" cols="12" md="6" sm="12" class="pb-0">
                  <v-text-field
                    v-model="weight.value"
                    :loading="loadingBatch"
                    :label="weight.label"
                    suffix="kg"
                    type="number"
                    class="text-field-right"
                    dense
                    outlined
                    persistent-placeholder
                  />
                </v-col>
                <v-col sm="12">
                  <v-btn
                    block
                    color="success"
                    :loading="loadingCalc"
                    @click="calcAndExport"
                  >
                    calcular
                  </v-btn>
               </v-col>

              </v-row>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
      <v-col class="sm-8">
        <v-row>
          <v-col sm="12">
            <transition
              name="custom-classes-transition"
              enter-active-class="animate__animated animate__fadeInUp"
            >
              <div v-if="results.length" class="print print-focus">

                <div class="d-flex">
                  <div class="mr-auto">
                    <h2 class="mb-0 text--secondary">Resultado</h2>
                    <p class="text--secondary"><i>{{ resultTitle }}</i></p>
                  </div>
                  <div class="d-flex pt-4 no-print">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn fab dark small color="#007bff" class="mr-2" @click="showAlert = !showAlert" v-on="on">
                          <v-icon dark>mdi-alert-circle-outline </v-icon>
                        </v-btn>
                      </template>
                      <span>Aviso Legal</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn fab dark small color="warning" class="mr-2" @click="openModalResults">
                          <v-icon dark>mdi-database </v-icon>
                        </v-btn>
                      </template>
                      <span>Dados</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn fab dark small color="primary" @click="print">
                          <v-icon dark>mdi-printer</v-icon>
                        </v-btn>
                      </template>
                      <span>Imprimir</span>
                    </v-tooltip>
                  </div>
                </div>

                <v-alert
                  border="left"
                  colored-border
                  color="green darken-4"
                  elevation="1"
                  class="print-only"
                >
                  <v-row>
                    <v-col sm="4" class="py-0">
                      <span class="subtitle-2">
                        Informações
                      </span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col sm="4">
                      <div class="body-1 d-flex justify-content-center align-items-center">
                        <v-icon class="title pr-2">mdi-account</v-icon> {{ farmSelected && farmSelected.customer.name | defaultEmpty }}
                      </div>
                      <div class="body-1 d-flex justify-content-center align-items-center mt-2">
                        <v-icon class="title pr-2">mdi-barn</v-icon> {{ farmSelected && farmSelected.name | defaultEmpty }}
                      </div>
                      <div class="body-1 d-flex justify-content-center align-items-center mt-2">
                        <v-icon class="title pr-2">mdi-view-module </v-icon> {{ moduleSelected && moduleSelected.text | defaultEmpty }}
                      </div>
                    </v-col>
                    <v-col sm="8">
                      <div class="body-1 d-flex justify-content-center align-items-center">
                        <v-icon class="title pr-2">mdi-calendar-clock</v-icon> {{ daysOccupationsSelected && daysOccupationsSelected.text | defaultEmpty }}
                      </div>
                      <div class="body-1 d-flex justify-content-center align-items-center mt-2">
                        <v-icon class="title pr-2">mdi-cow</v-icon> {{ animalLabel | defaultEmpty }}
                      </div>
                      <div v-if="supplementConsumption" class="body-1 d-flex justify-content-center align-items-center mt-2">
                        <v-icon class="title pr-2">mdi-food-takeout-box-outline</v-icon>
                        Suplementação de {{ supplementConsumption | number:decimals(2) }} kg de MN/cab/dia.
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-if="form.supplement_enabled && supplementConsumption">
                    <v-col sm="12" class="py-0">
                      <span class="subtitle-2">Detalhes da suplementação</span>
                    </v-col>
                    <v-col v-if="form.supplement_mineral_consumption" sm="4">
                      <div class="body-2"><strong>Mineral proteinado/energético</strong></div>
                      <div class="body-2">Consumo: {{ form.supplement_mineral_consumption | number:decimals(2) }} kg MN/cab/dia</div>
                      <div v-if="form.supplement_mineral_pb" class="body-2">Teor de PB: {{ form.supplement_mineral_pb | number:decimals(1) }}%</div>
                      <div v-if="form.supplement_mineral_ndt" class="body-2">Teor de NDT: {{ form.supplement_mineral_ndt | number:decimals(1) }}%</div>
                    </v-col>
                    <v-col v-if="form.supplement_feed_consumption" sm="4">
                      <div class="body-2"><strong>Ração concentrada</strong></div>
                      <div class="body-2">Consumo: {{ form.supplement_feed_consumption | number:decimals(2) }} kg MN/cab/dia</div>
                      <div v-if="form.supplement_feed_pb" class="body-2">Teor de PB: {{ form.supplement_feed_pb | number:decimals(1) }}%</div>
                      <div v-if="form.supplement_feed_ndt" class="body-2">Teor de NDT: {{ form.supplement_feed_ndt | number:decimals(1) }}%</div>
                      <div v-if="form.supplement_feed_fdn" class="body-2">Teor de FDN: {{ form.supplement_feed_fdn | number:decimals(1) }}%</div>
                    </v-col>
                    <v-col v-if="form.supplement_vol_consumption" sm="4">
                      <div class="body-2"><strong>Volumoso</strong></div>
                      <div class="body-2">Consumo: {{ form.supplement_vol_consumption | number:decimals(2) }} kg MN/cab/dia</div>
                      <div v-if="form.supplement_vol_ms" class="body-2">Teor de MS: {{ form.supplement_vol_ms | number:decimals(1) }}%</div>
                      <div v-if="form.supplement_vol_pb" class="body-2">Teor de PB: {{ form.supplement_vol_pb | number:decimals(1) }}%</div>
                      <div v-if="form.supplement_vol_em" class="body-2">Teor de EM: {{ form.supplement_vol_em | number:decimals(2) }} Mcal/kg</div>
                      <div v-if="form.supplement_vol_fdn" class="body-2">Teor de FDN: {{ form.supplement_vol_fdn | number:decimals(1) }}%</div>
                    </v-col>
                  </v-row>
                </v-alert>

                <v-row>
                  <v-col sm="4" >
                    <v-card color="success darken-2" dark>
                      <v-card-title class="subtitle-2">Máximo de cabeças</v-card-title>
                      <v-card-text>
                        <div class="py-3">
                          <h1 class="white--text">
                            {{ resultsRaw.results.numberOfHeads | number:decimals(0) }}
                            <span
                              v-if="['FEMEA_+24_PARIDA_PRENHA', 'FEMEA_+24_PARIDA_VAZIA'].includes(form.category_complementary)"
                              class="body-2"></span>
                          </h1>

                          <v-avatar class="icon-bottom-card">
                            <v-icon>mdi-alert-circle-check</v-icon>
                          </v-avatar>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col sm="4">
                    <v-card color="success darken-1" dark>
                      <v-card-title class="subtitle-2">Peso médio do lote</v-card-title>
                      <v-card-text>
                        <div class="py-3">
                          <h1 class="white--text">{{ resultsRaw.results.averageBatchWeight | number:decimals(1) }} kg</h1>

                          <v-avatar class="icon-bottom-card">
                            <v-icon>mdi-anvil</v-icon>
                          </v-avatar>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col sm="4">
                    <v-card color="success" dark>
                      <v-card-title class="subtitle-2">Desempenho previsto</v-card-title>
                      <v-card-text>
                        <div class="py-3">
                          <h1 class="white--text">
                            {{ resultsRaw.results.expectedPerformance | number:decimals(0) }} g/cab/dia
                            <v-tooltip v-if="alertExpectedPerformance" top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="warning"
                                  v-bind="attrs"
                                  size="21"
                                  v-on="on"
                                >
                                  mdi-alert
                                </v-icon>
                              </template>
                              <span>Este pasto não permite o desempenho escolhido.</span>
                            </v-tooltip>
                          </h1>

                          <v-avatar class="icon-bottom-card">
                            <v-icon>mdi-abacus</v-icon>
                          </v-avatar>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col sm="6">
                    <v-card>
                      <v-card-title class="subtitle-2">Dados do módulo e oferta ajustada</v-card-title>
                      <v-data-table
                        :headers="headerModuleDataAndAdjustedOffer"
                        :items="moduleDataAndAdjustedOffer"
                        hide-default-header
                        hide-default-footer
                      >
                        <template #item="{ item }">
                          <tr :class="(item.color || '') + ' text-right'">
                            <td>{{ item.label }}</td>
                            <td>
                              <strong>
                                <template v-if="['crudeProtein', 'fiberInNeutralDetergent'].indexOf(item.name) > -1">{{ moduleOfferDisplayValue(item) * 100 | percent(1) }}</template>
                                <template v-else-if="item.name === 'ndtAdjusted'">{{ moduleOfferDisplayValue(item) * 100 | percent(1) }}</template>
                                <template v-else-if="['availableDryMatter', 'maximumConsumptionPossible'].indexOf(item.name) > -1">{{ item.value | number:decimals(0) }}</template>
                                <template v-else-if="['metabolizableEnergy'].indexOf(item.name) > -1">{{ moduleOfferDisplayValue(item) | number:decimals(2) }}</template>
                                <template v-else-if="item.name !== 'qtdPaddocks'">{{ item.value | number:decimals(1) }}</template>
                                <template v-else>{{ item.value | number:decimals(0) }}</template>
                              </strong>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-col>
                  <v-col sm="6">
                    <v-card>
                      <v-card-title class="subtitle-2">Demais índices</v-card-title>
                      <v-data-table
                        :headers="headerResults"
                        :items="results"
                        hide-default-header
                        hide-default-footer
                      >
                        <template #item="{ item }">
                          <tr :class="`text-right ${item.color || ''} ${item.warning ? 'red--text' : ''}`">
                            <td>{{ item.label }}</td>
                            <td style="padding: 0 8px">
                              <strong>
                                <template v-if="item.name === 'arrobasProduced'">{{ item.value | number:decimals(1) }}</template>
                                <template v-else-if="item.name === 'expectedConsumption'">{{ item.value | number:decimals(2) }}</template>
                                <template v-else-if="item.name === 'consumptionByLiveWeight'">{{ item.value | percent }}</template>
                                <template v-else-if="item.name === 'moduleCapacity'">{{ item.value | number:decimals(1) }}</template>
                                <template v-else-if="['instantPicketCharge'].indexOf(item.name) > -1">{{ item.value | number:decimals(1) }}</template>
                                <template v-else>{{ item.value | number:decimals(1) }}</template>
                                <v-tooltip v-if="item.warning" top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      color="warning"
                                      v-bind="attrs"
                                      size="21"
                                      v-on="on"
                                    >
                                      mdi-alert-outline
                                    </v-icon>
                                  </template>
                                  <span>{{ item.warning }}</span>
                                </v-tooltip>
                              </strong>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row v-if="showAlert">
                  <v-col class="sm-8">
                    <v-card v-if="$vuetify.breakpoint.xs? false:true">
                      <v-card-title class="title-1">Aviso legal</v-card-title>
                      <v-card-text>
                        <span>
                          Nenhum conteúdo do Pastoreio de Precisão deve ser considerado como recomendação de diminuição/manutenção/aumento da quantidade de animais num lote específico ou na fazenda inteira. Tampouco como garantia de que será alcançado ou deixado de alcançar determinado desempenho por parte do gado.
            Deve, sim, ser considerado como o processamento de dados provenientes de imagens de satélite e sua tradução em números que auxiliam na tomada de decisão.
                        </span>
                      </v-card-text>
                    </v-card>
                    <v-expand-transition v-if="$vuetify.breakpoint.xs? true:false">
                      <v-expansion-panels>
                        <v-expansion-panel>
                          <v-card>
                            <v-expansion-panel-header>
                              <v-card-title class="title-1">Aviso legal</v-card-title>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-card-text>
                                <span>
                                  Nenhum conteúdo do Pastoreio de Precisão deve ser considerado como recomendação de diminuição/manutenção/aumento da quantidade de animais num lote específico ou na fazenda inteira. Tampouco como garantia de que será alcançado ou deixado de alcançar determinado desempenho por parte do gado.
                                  Deve, sim, se considerado como o processamento de dados provenientes de imagens de satélite e sua tradução em números que auxiliam na tomada de decisão.
                                </span>              
                              </v-card-text>
                            </v-expansion-panel-content>
                          </v-card>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-expand-transition>
                  </v-col>
                </v-row>
              </div>
            </transition>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <modal-results ref="modalResults" :results="resultsRaw" />
  </div>
</template>

<style scoped>
.icon-bottom-card {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 2.5rem;
}

.print-only {display:none;}

@media print {
  body :not(.both) {display:none;}
  .print-only  {display:block!important;}
}

</style>
